import React from "react"

const DeliveryPartnerDescription = props => {
  return (
    <div className="field-item even" property="content:encoded">
      <br></br>
      <h4>How to Apply</h4>
      <br></br>
      <p>
        <ul>
          <li>
          <strong>Download and Review the Template:</strong> Download the
        template for application and review it carefully, to understand the
        requirement
          </li>
          <li>
          <strong>Fill Out the Application Template:</strong> Complete
          the application form accurately and thoroughly.
          </li>
          <li>
          <strong>Prepare Documents:</strong> Gather all required
        documents (e.g., letter for application, track record, legal status
        document, ect).
          </li>
          <li>
          <strong>Submit the Application:</strong> Follow the
          submission instructions, and attach all required documents and submit
          </li>
        </ul>
        
      </p>
      Please go through the following links that have downloadable templates to
      guide you on the application processes.
      <ul>
        <li>
          <a href="http://apitest.rema.gov.rw/files/project-preparation-funding-application.docx">
            <strong>Project Preparation Funding Application</strong>
          </a>
        </li>
        <li>
          <a href="http://apitest.rema.gov.rw/files/sap-concept-note-redd.docx">
            <strong>SAP Concept Note</strong>
          </a>
        </li>
        <li>
          <a href="http://apitest.rema.gov.rw/files/form-fp-template-pap">
            <strong>Form Full Proposal Template</strong>
          </a>
        </li>
        <li>
          <a href="http://apitest.rema.gov.rw/files/form-01-concept-note.docx">
            <strong>Form Concept Note</strong>
          </a>
        </li>
      </ul>
    </div>
  )
}

export default DeliveryPartnerDescription
